<template>
  <div id="Sales-Ledger-Report">
    <div class="container admin-wrap mt-5">
      <div class="row header mb-3">
        <div class="col-lg-5">
          <h3 class="text-left">SALES LEDGER</h3>
        </div>
        <div class="col-lg-7">
          <el-select v-model="ddlSelectedDateRangeValue" placeholder="View By" @change="Search('dateRange')">
            <el-option v-for="items in ddlDateRangeSelection" :value="items.value" :key="items.value">
              {{ items.text }}
            </el-option>
          </el-select>
          <!--<el-select v-on:change="loadSelector()" v-model="ddlSelectedValue"-->
          <!--placeholder="Select Filter/Criteria">-->
          <!--<el-option v-for="items in ddlSelection" :value="items.value" :key="items.value">{{items.text}}</el-option>-->
          <!--</el-select>-->
          <!--<div v-if="ddlSelectedValue==='dateFrom'">-->
          <el-date-picker
            v-model="inputFromDate"
            type="daterange"
            range-separator="TO"
            start-placeholder="From Date"
            end-placeholder="To Date"
            format="dd/MM/yyyy"
            value-format="dd/MM/yyyy"
            @change="Search('dateFrom')"
          >
          </el-date-picker>
          <!--</div>-->
        </div>
      </div>
      <div class="empty-list_image" v-if="SalesLedgerListInt.length < 1">
        <strong>{{ startupText }}</strong>
        <img src="../assets/notfound.png" />
      </div>
      <div>
        <div class="">
          <!--<h5 class="text-left mb-3">Sales Ledger</h5>-->
          <!--<hr>-->
          <!--<div class="row row-no-gutters">-->
          <!--<div>-->
          <!--</div>-->
          <!--<div class="col-lg-4 col-md-4 col-sm-4 col-xs-12" v-if="ddlSelectedValue=='dateRange'">-->
          <!--<el-form >-->
          <!--<el-form-item label="Select Date Range">-->
          <!--<el-select v-model="ddlSelectedDateRangeValue"-->
          <!--placeholder="Please select:">-->
          <!--<el-option v-for="items in ddlDateRangeSelection" :value="items.value">{{items.text}}</el-option>-->
          <!--</el-select>-->
          <!--</el-form-item>-->
          <!--</el-form>-->
          <!--</div>-->
          <!--<div>-->
          <!--<br><br>-->
          <!--<button class="btn btn-success searchbtn" id="btnSearch" v-on:click="Search()">Search</button>-->
          <!--</div>-->
          <!--</div>-->
          <el-tabs v-model="activeReport" type="card" v-if="SalesLedgerListInt.length > 0 || CNRefundListInt.length > 0" class="mt-3">
            <el-tab-pane label="SALES LEDGER REPORT" name="first">
              <div v-if="SalesLedgerListInt.length > 0" class="datatable_group">
                <el-button size="small" type="primary" icon="el-icon-download" v-on:click="Download()" class="pull-right mb-3" :disabled="AuditDisabled"
                  >Download
                </el-button>
                <data-tables
                  :data="SalesLedgerListInt"
                  :page-size="pageSize"
                  :pagination-props="{ pageSizes: [pageSize, 100] }"
                  width="55"
                  stripe
                  tooltip-effect="light"
                  border
                  ref="SalesLedgerListTable"
                >
                  <el-table-column label="#" min-width="45px">
                    <template slot-scope="scope">
                      <!--                            {{(scope.$index)+1}}-->
                      {{ scope.row.Index }}
                    </template>
                  </el-table-column>
                  <el-table-column v-for="item in SalesLedgerList" min-width="150px" :prop="item.prop" :label="item.label" :key="item.prop" sortable="custom">
                  </el-table-column>
                </data-tables>
              </div>
            </el-tab-pane>
            <el-tab-pane label="CREDIT NOTE DETAILS" name="second">
              <div v-if="CNRefundListInt.length > 0" class="datatable_group">
                <data-tables
                  :data="CNRefundListInt"
                  :page-size="pageSize"
                  :pagination-props="{ pageSizes: [pageSize, 100] }"
                  width="55"
                  stripe
                  tooltip-effect="light"
                  border
                  ref="SalesLedgerListTable"
                >
                  <el-table-column label="#" min-width="45px">
                    <template slot-scope="scope">
                      <!--                            {{(scope.$index)+1}}-->
                      {{ scope.row.Index }}
                    </template>
                  </el-table-column>
                  <el-table-column v-for="item in CNRefundList" min-width="150px" :prop="item.prop" :label="item.label" :key="item.prop" sortable="custom">
                  </el-table-column>
                </data-tables>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataSource from '../data/datasource'
import XLSX from 'xlsx'
import Cookies from 'js-cookie'

export default {
  name: 'SalesLedgerReport',
  async created() {
    //todo: for external auditor only
    let conType = Cookies.get('userTypeSession')
    if (conType === 'Auditor') {
      this.AuditDisabled = true
    }
    //todo: for external auditor only
  },
  async mounted() {},
  data() {
    return {
      activeReport: 'first',
      ddlSelection: [
        { text: 'Date Range', value: 'dateRange' },
        { text: 'DateFrom/DateTo', value: 'dateFrom' },
      ],
      ddlDateRangeSelection: [
        { text: 'Week', value: 'week' },
        { text: 'Month', value: 'month' },
        { text: 'Year', value: 'year' },
      ],
      SalesLedgerListInt: [],
      SalesLedgerList: [
        {
          prop: 'IH_Invoice_Date_Convert_Mon',
          label: 'DATE',
        },
        {
          prop: 'CLS_ClassName',
          label: 'CLASS',
        },
        {
          prop: 'IH_Invoice_No',
          label: 'INV NO',
        },
        {
          prop: 'Full_Name',
          label: 'First Name',
        },
        {
          prop: 'Last_name',
          label: 'Last Name',
        },
        {
          prop: 'itemTotalAmount',
          label: 'TOTAL',
        },
        {
          prop: 'itemGstAmount',
          label: 'GST',
        },
        {
          prop: 'insurance',
          label: 'INSURANCE',
        },
        {
          prop: 'mealCharges',
          label: 'MEAL CHARGES',
        },
        {
          prop: 'subsidy',
          label: 'SUBSIDY',
        },
        {
          prop: 'regFee',
          label: 'Reg.Fee',
        },
        {
          prop: 'others',
          label: 'OTHERS',
        },
        {
          prop: 'schoolFee',
          label: 'SCHOOL FEES',
        },
        {
          prop: 'refundableDeposit',
          label: 'REFUNDABLE DEPOSIT',
        },
        {
          prop: 'siblingDiscount',
          label: 'SIBLING DISCOUNT',
        },
      ],
      CNRefundListInt: [],
      CNRefundList: [
        {
          prop: 'IH_Invoice_Date_Convert_Mon',
          label: 'DATE',
        },
        {
          prop: 'CLS_ClassName',
          label: 'CLASS',
        },
        {
          prop: 'IH_Invoice_No',
          label: 'CR NO',
        },
        {
          prop: 'Full_Name',
          label: 'First Name',
        },
        {
          prop: 'Last_name',
          label: 'Last Name',
        },
        {
          prop: 'insurance',
          label: 'INSURANCE',
        },
        {
          prop: 'refundableDeposit',
          label: 'REFUNDABLE DEPOSIT',
        },
        {
          prop: 'others',
          label: 'OTHERS',
        },
        {
          prop: 'mealCharges',
          label: 'MEAL CHARGES',
        },
        {
          prop: 'schoolFee',
          label: 'SCHOOL FEES',
        },
        {
          prop: 'siblingDiscount',
          label: 'SIBLING DISCOUNT',
        },
        {
          prop: 'itemGstAmount',
          label: 'GST',
        },
        {
          prop: 'itemTotalAmount',
          label: 'TOTAL',
        },
        {
          prop: 'IH_Invoice_Name',
          label: 'INV NO',
        },
        {
          prop: 'IH_Invoice_Type',
          label: 'Type',
        },
      ],
      ddlSelectedValue: '',
      ddlSelectedDateRangeValue: '',
      inputFromDate: [],
      startupText: '',
      pageSize: 50,

      AuditDisabled: false,
    }
  },
  methods: {
    ClearAllList() {
      this.CNRefundListInt = []
      this.SalesLedgerListInt = []
    },

    loadSelector() {
      try {
        //  console.log(this.ddlSelectedValue);
      } catch (e) {
        this.results = e
      }
    },
    async Search(ddlSelectedValue) {
      try {
        this.ddlSelectedValue = ddlSelectedValue
        this.startupText = 'No Data Found...'
        await this.ClearAllList()
        if (!this.ddlSelectedValue) {
          this.$notify({
            title: 'Require',
            message: '"Please select criteria"',
          })
        } else if (this.inputFromDate.length < 1 && !this.ddlSelectedDateRangeValue) {
          this.$notify({
            title: 'Require',
            message: '"Please select date"',
          })
        } else {
          this.$vs.loading()

          if (this.ddlSelectedValue == 'dateRange') {
            this.inputFromDate = []
          } else if (this.ddlSelectedValue == 'dateFrom') {
            this.ddlSelectedDateRangeValue = ''
          }
          if (1 == 1) {
            const response = await DataSource.shared.getSalesLedger('invoice', this.ddlSelectedDateRangeValue, this.inputFromDate[0], this.inputFromDate[1])

            if (response) {
              if (response.code === '88') {
                window.location.replace('/')
              } else if (response.code === '99') {
                this.$notify.error({
                  title: 'Error',
                  message: 'Error 99!',
                })
              } else if (response.code === '2') {
                this.$notify({
                  title: 'No Record',
                  message: 'No Record Found',
                })
              } else {
                let cuztomizeList = []
                cuztomizeList = response.Table
                let Index = 1
                cuztomizeList.forEach(m => {
                  let tempList = {
                    Index: Index,
                    IH_Invoice_Date_Convert_Mon: m.IH_Invoice_Date_Convert_Mon,
                    CLS_ClassName: m.CLS_ClassName.trim(),
                    IH_Invoice_No: m.IH_Invoice_No,
                    studentName: m.studentName,
                    Full_Name: m.Full_Name,
                    Last_name: m.Last_name,
                    itemTotalAmount: m.itemTotalAmount,
                    itemGstAmount: m.itemGstAmount,
                    insurance: m.insurance,
                    mealCharges: m.mealCharges,
                    subsidy: m.subsidy,
                    registrationFee: m.registrationFee,
                    schoolFee: m.schoolFee,
                    others: m.others,
                    refundableDeposit: m.refundableDeposit,
                    siblingDiscount: m.siblingDiscount,
                  }
                  Index++
                  this.SalesLedgerListInt.push(tempList)
                })
                // this.SalesLedgerListInt = response.Table;
              }
            }
          }
          if (2 == 2) {
            const response = await DataSource.shared.getSalesLedger('cn', this.ddlSelectedDateRangeValue, this.inputFromDate[0], this.inputFromDate[1])

            if (response) {
              if (response.code === '88') {
                window.location.replace('/')
              } else if (response.code === '99') {
                this.$notify.error({
                  title: 'Error',
                  message: 'Error 99!',
                })
              } else if (response.code === '2') {
                this.$notify({
                  title: 'No Record',
                  message: 'No Record Found',
                })
              } else {
                let cuztomizeList = []
                cuztomizeList = response.Table
                let Index = 1
                cuztomizeList.forEach(m => {
                  let tempList = {
                    Index: Index,
                    IH_Invoice_Date_Convert_Mon: m.IH_Invoice_Date_Convert_Mon,
                    CLS_ClassName: m.CLS_ClassName.trim(),
                    IH_Invoice_No: m.IH_Invoice_No,
                    studentName: m.studentName,
                    Full_Name: m.Full_Name,
                    Last_name: m.Last_name,
                    IH_Invoice_Type: m.IH_Invoice_Type,
                    insurance: m.insurance,
                    refundableDeposit: m.refundableDeposit,
                    others: m.others,
                    mealCharges: m.mealCharges,
                    schoolFee: m.schoolFee,
                    siblingDiscount: m.siblingDiscount,
                    itemGstAmount: m.itemGstAmount,
                    itemTotalAmount: m.itemTotalAmount,
                    IH_Invoice_Name: m.IH_Invoice_Name,
                  }
                  this.CNRefundListInt.push(tempList)
                  Index++
                })
                // this.CNRefundListInt = response.Table;
              }
            }
          }

          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '99') {
              this.$notify.error({
                title: 'Error',
                message: 'Error 99!',
              })
            } else if (response.code === '2') {
              this.$notify({
                title: 'No Record',
                message: 'No Record Found',
              })
            } else {
              this.SalesLedgerListInt = response.Table
            }
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },

    Download() {
      this.exportExcel()
    },

    exportExcel() {
      let exportSLExcelObject = []
      let exportCNExcelObject = []

      var currentDateWithFormat = new Date().toJSON().slice(0, 10).replace(/-/g, '/')

      if (1 == 1) {
        this.SalesLedgerListInt.forEach(m => {
          let tempList = {
            DATE: m.IH_Invoice_Date_Convert_Mon,
            CLASS: m.CLS_ClassName.trim(),
            'INV NO': m.IH_Invoice_No,
            'First Name': m.Full_Name,
            'Last Name': m.Last_name,
            TOTAL: m.itemTotalAmount,
            GST: m.itemGstAmount,
            INSURANCE: m.insurance,
            'MEAL CHARGES': m.mealCharges,
            SUBSIDY: m.subsidy,
            'Reg.Fee': m.registrationFee,
            OTHERS: m.others,
            'SCHOOL FEES': m.schoolFee,
            'REFUNDABLE DEPOSIT': m.refundableDeposit,
            'SIBLING DISCOUNT': m.siblingDiscount,
          }
          exportSLExcelObject.push(tempList)
        })
      }
      if (2 == 2) {
        this.CNRefundListInt.forEach(m => {
          let tempList = {
            DATE: m.IH_Invoice_Date_Convert_Mon,
            CLASS: m.CLS_ClassName.trim(),
            'CR NO': m.IH_Invoice_No,
            'First Name': m.Full_Name,
            'Last Name': m.Last_name,
            INSURANCE: m.insurance,
            'REFUNDABLE DEPOSIT': m.refundableDeposit,
            OTHERS: m.others,
            'MEAL CHARGES': m.mealCharges,
            'SCHOOL FEES': m.schoolFee,
            'SIBLING DISCOUNT': m.siblingDiscount,
            GST: m.itemGstAmount,
            TOTAL: m.itemTotalAmount,
            'INV NO': m.IH_Invoice_Name,
            Type: m.IH_Invoice_Type,
          }
          exportCNExcelObject.push(tempList)
        })
      }

      if (1 == 1) {
        //todo: invoice object
        var listInvoiceItemCount = exportSLExcelObject.length
        var sheet1WS = XLSX.utils.json_to_sheet(exportSLExcelObject)
        var wb = XLSX.utils.book_new() // make Workbook of Excel

        var newRange = { s: { r: 0, c: 0 }, e: { r: listInvoiceItemCount, c: 16 } }
        for (var R = newRange.s.r; R <= newRange.e.r; ++R) {
          for (var C = newRange.s.c; C <= newRange.e.c; ++C) {
            if (R <= listInvoiceItemCount && C == 0) {
              var cell = sheet1WS[XLSX.utils.encode_cell({ r: R, c: C })]
              cell.z = 'd/m/yyyy'
              // console.log('R=',R,'C=',C);
            }
            if (R <= listInvoiceItemCount && C == 5) {
              var fmt = '_(* #,##0.00_);_(* (#,##0.00);_(* "-"??_);_(@_)'
              var cell = sheet1WS[XLSX.utils.encode_cell({ r: R, c: C })]
              cell.z = fmt
              // console.log('R=',R,'C=',C);
            }
            if (R <= listInvoiceItemCount && C == 6) {
              var fmt = '_(* #,##0.00_);_(* (#,##0.00);_(* "-"??_);_(@_)'
              var cell = sheet1WS[XLSX.utils.encode_cell({ r: R, c: C })]
              cell.z = fmt
              //console.log('R=',R,'C=',C);
            }
          }
        }

        XLSX.utils.book_append_sheet(wb, sheet1WS, 'sheet1') // sheetAName is name of Worksheet
        XLSX.writeFile(wb, 'SalesLedger - ' + currentDateWithFormat + '.xlsx') // name of the file is 'book.xlsx'
      }
      if (2 == 2) {
        //todo: CN object
        // var listCNItemCount= exportCNExcelObject.length;
        var sheet2WS = XLSX.utils.json_to_sheet(exportCNExcelObject)
        var wb2 = XLSX.utils.book_new() // make Workbook of Excel
        XLSX.utils.book_append_sheet(wb2, sheet2WS, 'sheet2') // sheetAName is name of Worksheet
        XLSX.writeFile(wb2, 'CN - ' + currentDateWithFormat + '.xlsx') // name of the file is 'book.xlsx'
        //var newRange = {s:{r:0,c:4},e:{r:listCNItemCount,c:9}};
      }
    },
  },
}
</script>
<style>
#Sales-Ledger-Report .header .el-select {
  margin: 0 10px;
}

#Sales-Ledger-Report .header span.el-range-separator {
  width: 32px;
}
</style>
